"use client";
import { useSetAtom } from "jotai";
import { useCallback } from "react";
import { toast } from "react-toastify";
import { logoutAction } from "../actions/profile.actions";
import { userAtom } from "../store/userAtom";
import { Routes } from "../utils/clientRoutes";
import { useRouter } from "next/navigation";

const useOnLogout = () => {
  const setUser = useSetAtom(userAtom);
  const router = useRouter();
  const logout = useCallback(async () => {
    const text = await logoutAction();
    if (text) toast.success(text);
    setUser(null);
    localStorage.removeItem("token");
    router.push(Routes.home);
    router.refresh();
  }, [router, setUser]);

  return { logout };
};

export default useOnLogout;
